import React, { Component } from 'react'
import { RouterView } from '@merchant-backend/common-components'
import Header from './header'
import Store from './store'
import { observer } from 'mobx-react'
import Publish from './Publish'
import { toJS } from 'mobx'
import List from './List'
import { Link } from 'react-router'

@observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.params.id)
  }
  componentDidMount() {
    this.store.getTopicDetail()
    this.store.getNoteList()
  }
  render() {
    const detailInfo = toJS(this.store.detailInfo)
    const noteList = toJS(this.store.noteList)
    return (
      <div>
        <RouterView
          header={[
            <Link to="/localMerchant/contentCenter">内容中心</Link>,
            '话题详情'
          ]}
          title={<Header detailInfo={detailInfo} />}
          titleStyle={{ height: '140px', padding: '20px 30px' }}
          bodyStyle={{ padding: '0 30px 20px 30px' }}
        >
          <Publish topicId={this.store.id} store={this.store} />
        </RouterView>
        <RouterView
          bodyStyle={{ padding: '0 30px 20px 30px' }}
          contentStyle={{ margin: '0' }}
        >
          <List noteList={noteList} />
        </RouterView>
      </div>
    )
  }
}

export default Index
